/* ----- Automatic checks. Run on every composed ritual. ----- */
function runChecks(res){
  const out=[];const add=(name,pass,detail)=>out.push({name,pass,detail:detail||""});
  const allK=res.chapters.flatMap(c=>c.items.map(i=>i.k));
  /* 1: one final moisturizer or overnight seal per sitting (Sea Lavender and Moonlit alternate nights by copy, never the same night) */
  let sealsOk=true,sealDetail="";
  res.chapters.forEach(c=>{
    const seals=c.items.filter(i=>i.slot==="seal");
    const hero=c.items.filter(i=>i.slot==="seal-hero");
    if(seals.length>1){sealsOk=false;sealDetail="two seals in one sitting";}
    if(hero.length&&seals.length>1){sealsOk=false;}
  });
  add("One final moisturizer per sitting",sealsOk,sealDetail||(allK.includes("sealavender")?"Sea Lavender nights stand alone; the cocoon cream takes the ordinary nights":""));
  /* 2: Luscious never described as weightless */
  const lus=res.chapters.flatMap(c=>c.items).filter(i=>i.k==="luscious");
  add("Luscious never described as weightless",lus.every(i=>!/weightless/i.test(i.why)));
  /* 3: Illume is the true weightless option */
  const nonIllume=res.chapters.flatMap(c=>c.items).filter(i=>i.k!=="illume"&&i.slot!=="treat"&&/weightless gel|barely feel|weightless is/i.test(i.why));
  const texW=res.tex===0;
  const dSeals=res.chapters.filter(c=>c.head==="Morning"||(!c.head&&res.timing!=="pm")).flatMap(c=>c.items).filter(i=>i.slot==="seal");
  const wOk=!nonIllume.length&&(!texW||res.path==="rocco"||res.path==="bianca"||dSeals.every(s=>s.k==="illume"));
  add("Illume is the true weightless option",wOk,texW&&(res.path==="rocco")?"shave seal is the one exception, by rule":"");
  /* 4: Sea Lavender and Alpine never together */
  add("Sea Lavender and Alpine never share a result",!(allK.includes("sealavender")&&allK.includes("alpine")));
  /* 5: Splendid never after shaving */
  add("Splendid never joins the shave path",res.path!=="rocco"||(!allK.includes("splendid")&&!res.enhance.some(e=>e.k==="splendid")));
  /* 6: Orchid always before the moisturizer */
  let orchidOk=true;
  res.chapters.forEach(c=>{
    const oi=c.items.findIndex(i=>i.k==="orchid");
    if(oi>=0){const si=c.items.findIndex(i=>i.slot==="seal");orchidOk=orchidOk&&si>oi;}
  });
  add("Orchid always sits before the moisturizer",orchidOk);
  /* 7: Moonlit only ever an evening final moisturizer */
  let moonOk=true;
  res.chapters.forEach(c=>{
    c.items.forEach(i=>{if(i.k==="moonlit"){if(i.slot!=="seal")moonOk=false;if(c.head==="Morning")moonOk=false;if(!c.head&&res.timing==="am")moonOk=false;}});
  });
  add("Moonlit is always an evening final moisturizer",moonOk);
  /* 8: morning-only results contain no night-only steps */
  const NIGHT=["moonlit","sealavender","orchid","splendid","alpine","miracle"];
  add("Morning-only rituals carry no night steps",res.timing!=="am"||!allK.some(k=>NIGHT.includes(k)));
  /* 9: evening-only results contain no morning-only steps and no SPF */
  add("Evening-only rituals carry no morning steps",res.timing!=="pm"||(!allK.includes("magnolia")&&res.chapters.every(c=>!c.spf&&c.head!=="Morning")));
  /* 10: Splendid is the ritual preparation step: evenings only, after cleansing,
     before the treatment serum, introduced gradually, never framed as harsh */
  let prepOk=true,prepDetail="";
  res.chapters.forEach(c=>{
    const si=c.items.findIndex(i=>i.k==="splendid");
    if(si<0)return;
    if(c.head==="Morning"||(!c.head&&res.timing==="am")){prepOk=false;prepDetail="Splendid appeared in a morning sitting";}
    const ci=c.items.findIndex(i=>i.slot==="cleanse");
    if(ci>=0&&si<ci){prepOk=false;prepDetail="Splendid placed before the cleanse";}
    const ai=c.items.findIndex(i=>i.slot==="anchor");
    if(ai>=0&&si>ai){prepOk=false;prepDetail="Splendid placed after the serum step";}
    const sp=c.items[si];
    if(!/built gradually|to begin/i.test(sp.why)){prepOk=false;prepDetail="gradual introduction missing from the preparation copy";}
    if(/\bharsh\b|\baggressive\b|\bpeel\b|dead skin|\bmonthly\b|occasional-only/i.test(sp.role+" "+sp.why)){prepOk=false;prepDetail="banned framing on the preparation step";}
  });
  add("Splendid is the preparation: after cleansing, before the serum, built gradually",prepOk,prepDetail);
  /* 11: Magnolia is morning only */
  let magOk=true;
  res.chapters.forEach(c=>{c.items.forEach(i=>{if(i.k==="magnolia"){if(c.head==="Evening")magOk=false;if(!c.head&&res.timing==="pm")magOk=false;}});});
  add("Magnolia is morning only",magOk);
  /* 12: Sea Lavender and Moonlit alternate nights, never layered */
  let altOk=true;
  res.chapters.forEach(c=>{
    const sl=c.items.find(i=>i.k==="sealavender"),mo=c.items.find(i=>i.k==="moonlit");
    if(sl&&mo){if(sl.slot!=="seal-hero")altOk=false;if(!/alone|in between|ordinary nights/i.test(sl.why+" "+mo.why))altOk=false;}
  });
  add("Sea Lavender and Moonlit alternate, never layered",altOk);
  /* 13: no duplicate product functions and no repeated product within one sitting */
  let dupOk=true,dupDetail="";
  res.chapters.forEach(c=>{
    ["cleanse","anchor","seal","prep","infusion","seal-hero"].forEach(sl=>{
      if(c.items.filter(i=>i.slot===sl).length>1){dupOk=false;dupDetail="duplicate "+sl+" step in one sitting";}
    });
    const keys=c.items.map(i=>i.k);
    if(new Set(keys).size!==keys.length){dupOk=false;dupDetail="a product repeated within one sitting";}
  });
  add("No duplicate functions within a sitting",dupOk,dupDetail);
  /* 14: customer-facing copy stays claim-safe; internal terms never surface */
  const BAN=/dead skin|\bharsh\b|\baggressive\b|\bpeel\b|\bacne\b|inflammat|\bheal\b|\bheals\b|\bhealing\b|bacteria|\bpurge\b|anti-?aging|early aging|retinol|clinical|blemish|microbiome|medicated|pigmentation|\brepair\b|\brepairs\b|\brepairing\b/i;
  const copyPool=[res.title,res.told,res.seq,...res.decisions,...res.enhance.map(e=>e.text),...res.bench.map(k=>BENCH[k]||""),...res.chapters.flatMap(c=>c.items.map(i=>i.role+" "+i.why))].join(" | ");
  const banHit=copyPool.match(BAN);
  add("Customer copy stays claim-safe",!banHit,banHit?("found: "+banHit[0]):"");
  /* 15: Orchid exclusions (v1.0A): never with Weightless, never in a morning sitting, never on Clarity, Resilience, or Shave */
  let orcExOk=true,orcExDetail="";
  if(allK.includes("orchid")){
    if(res.tex===0){orcExOk=false;orcExDetail="Orchid appeared with the Weightless texture";}
    if(["bianca","mara","rocco"].includes(res.path)){orcExOk=false;orcExDetail="Orchid appeared on an excluded path";}
    res.chapters.forEach(c=>{
      const hasO=c.items.some(i=>i.k==="orchid");
      if(hasO&&(c.head==="Morning"||(!c.head&&res.timing==="am"))){orcExOk=false;orcExDetail="Orchid appeared in a morning sitting";}
    });
  }
  add("Orchid keeps its exclusions: evenings only, never Weightless, never Clarity, Resilience, or Shave",orcExOk,orcExDetail);
  /* 16: Keys appears only on a glow signal (v1.0A) */
  const hasKeys=res.enhance.some(e=>e.k==="keys")||allK.includes("keys");
  const glowSignal=res.path==="daniela"||((res.path==="elena"||res.path==="petra")&&res.q7===3);
  add("Keys appears only on a glow signal",!hasKeys||glowSignal,hasKeys&&!glowSignal?"Keys appeared without a glow signal":"");
  /* 17: the absolute three-step rule for simple edits (v1.0A): cleanse, one treatment or anchor, one final seal, never more */
  let threeOk=true,threeDetail="";
  if(res.simple){
    res.chapters.forEach(c=>{
      const core=c.items.filter(i=>i.slot!=="eye");
      const finalSeals=core.filter(i=>i.slot==="seal"||i.slot==="seal-hero");
      const others=core.filter(i=>i.slot!=="seal"&&i.slot!=="seal-hero");
      /* Sea Lavender and Moonlit alternate nights, so the pair counts as one final step */
      const finalCount=finalSeals.length?1:0;
      if(others.length+finalCount>3){threeOk=false;threeDetail=(others.length+finalCount)+" core steps in a simple-edit sitting";}
    });
  }
  add("Simple edits hold the absolute three-step rule",threeOk,threeDetail);
  /* 18: no em dashes anywhere in customer-facing copy */
  const dashHit=copyPool.match(/[—–]/);
  add("No em dashes in customer copy",!dashHit);
  return out;
}

/* Node/module export for headless QA, harmless in the browser */
if(typeof module!=="undefined"&&module.exports){module.exports={P,BENCH,QUESTIONS,ROMAN,FINISH,SHORT,PATH_NAMES,CANONICAL,composeRitual,runChecks,basePath};}
